import { Fragment } from "react";
import CustomDatePicker from "../../UI/CustomDatePicker/CustomDatePicker";
import ScratchSimpleSelectOption from "../../UI/ScratchSimpleSelectOption/ScratchSimpleSelectOption";
import classes from "./TableColumnSearchInputs.module.css";
import SearchType from "./SearchType";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";

const formatMoney = (value) => {
  const numericValue = value.replace(/[^0-9]/g, "") === "" ? null : value.replace(/[^0-9]/g, "");
  return numericValue;
};
const formatMoneyWithCommas = (value) => {
  return new Intl.NumberFormat().format(value);
};
const TableColumnSearchInputs = ({
  searchHandler,
  view,
  selectable,
  showSearchRow,
  tableInfos,
  searchVal,
  enumOptions,
  setSearchVal,
  forceLtr,
  setSearchTypes,
  searchTypes,
}) => {
  return (
    <tr
      className={[classes.headRow, showSearchRow ? classes.showHeadRow : classes.hideHeadRow].join(" ")}
    >
      {selectable ? <th className={classes.checkboxTh} /> : null}
      <th className={classes.indexTh}></th>
      {tableInfos
        .sort((a, b) => a.order - b.order)
        .map((inf) => (
          <Fragment key={inf.uniqueName}>
            {inf.show ? (
              <th
                className={[
                  classes.thSearch,
                  inf.field === "code" ? classes.codeTh : null,
                  /^is[A-Z]/.test(inf.field) ? classes.statusTh : null,
                ].join(" ")}
              >
                <span className={classes.searchInputContainer}>
                  {inf?.type === "boolean" ? (
                    <ScratchSimpleSelectOption
                      name={inf.uniqueName}
                      value={searchVal[inf.uniqueName]}
                      options={inf.options}
                      // onChange={searchHandler}
                      onChange={(e) => {
                        searchHandler({
                          target: {
                            name: e.target.name,
                            value: e.target.value?.value ? e.target.value.value : "",
                          },
                        });
                      }}
                      style="tableSearch"
                      deletable={true}
                      valueType="boolean"
                      forceLtr={forceLtr}
                    />
                  ) : inf?.type === "date" ? (
                    <>
                      <CustomDatePicker
                        changeDateHandler={(newValue) =>
                          searchHandler({
                            target: {
                              name: inf.uniqueName,
                              value: newValue ? (inf.attachTime ? `${newValue}T00:00` : newValue) : "",
                              subName: "from",
                            },
                          })
                        }
                        value={searchVal[inf.uniqueName]?.from}
                        showDeleteBtn={true}
                        style="tableSearch"
                        forceLtr={forceLtr}
                        label={forceLtr ? "from" : <MultiLanTxt tid="FROM" />}
                        skipFieldAccessCheck={true}
                      />
                      {/* - */}
                      <CustomDatePicker
                        changeDateHandler={(newValue) =>
                          searchHandler({
                            target: {
                              name: inf.uniqueName,
                              value: newValue ? (inf.attachTime ? `${newValue}T00:00` : newValue) : "",
                              subName: "to",
                            },
                          })
                        }
                        value={searchVal[inf.uniqueName]?.to}
                        showDeleteBtn={true}
                        style="tableSearch"
                        forceLtr={forceLtr}
                        label={forceLtr ? "to" : <MultiLanTxt tid="TO" />}
                        skipFieldAccessCheck={true}
                      />
                    </>
                  ) : inf?.type === "rangedNumber" ? (
                    <>
                      {
                        <label className={classes.rangedNumLabel} htmlFor={`${inf.uniqueName}_from`}>
                          {forceLtr ? "from" : <MultiLanTxt tid="FROM" />}
                        </label>
                      }
                      <input
                        id={`${inf.uniqueName}_from`}
                        autoComplete="off"
                        className={classes.serachInput}
                        name={inf.uniqueName}
                        onChange={(e) =>
                          searchHandler({
                            target: {
                              name: inf.uniqueName,
                              value: inf?.withSeparator ? formatMoney(e.target.value) : e.target.value,
                              subName: "from",
                            },
                          })
                        }
                        value={
                          inf?.withSeparator
                            ? searchVal[inf.uniqueName]?.from === "" ||
                              searchVal[inf.uniqueName]?.from === null
                              ? ""
                              : formatMoneyWithCommas(searchVal[inf.uniqueName]?.from)
                            : searchVal[inf.uniqueName]?.from
                        }
                      />
                      {
                        <label className={classes.rangedNumLabel} htmlFor={`${inf.uniqueName}_to`}>
                          {forceLtr ? "to" : <MultiLanTxt tid="TO" />}
                        </label>
                      }
                      <input
                        id={`${inf.uniqueName}_to`}
                        autoComplete="off"
                        className={classes.serachInput}
                        name={inf.uniqueName}
                        onChange={(e) =>
                          searchHandler({
                            target: {
                              name: inf.uniqueName,
                              value: inf?.withSeparator ? formatMoney(e.target.value) : e.target.value,
                              subName: "to",
                            },
                          })
                        }
                        value={
                          inf?.withSeparator
                            ? searchVal[inf.uniqueName]?.to === "" ||
                              searchVal[inf.uniqueName]?.to === null
                              ? ""
                              : formatMoneyWithCommas(searchVal[inf.uniqueName]?.to)
                            : searchVal[inf.uniqueName]?.to
                        }
                      />
                    </>
                  ) : inf?.type === "enum" ? (
                    <ScratchSimpleSelectOption
                      name={inf.uniqueName}
                      value={searchVal[inf.uniqueName]}
                      options={enumOptions ? enumOptions[inf.uniqueName] : []}
                      onChange={(e) => {
                        searchHandler({
                          target: {
                            name: e.target.name,
                            value: e.target?.value ? e.target.value : "",
                          },
                        });
                      }}
                      style="tableSearch"
                      deletable={true}
                    />
                  ) : (
                    <input
                      autoComplete="off"
                      className={classes.serachInput}
                      type="text"
                      name={inf.uniqueName}
                      onChange={searchHandler}
                      placeholder={forceLtr ? "Search" : "جست و جو"}
                      value={searchVal[inf.uniqueName] || ""}
                    />
                  )}
                  {inf?.type === "date" ||
                  inf?.type === "rangedNumber" ||
                  inf?.type === "enum" ||
                  inf?.type === "boolean" ? null : (
                    <SearchType
                      setSearchTypes={setSearchTypes}
                      name={inf.uniqueName}
                      searchTypes={searchTypes}
                      forceLtr={forceLtr}
                    />
                  )}
                </span>
              </th>
            ) : null}
          </Fragment>
        ))}
      {view ? null : <th className={classes.thView} />}
    </tr>
  );
};

export default TableColumnSearchInputs;
